module.exports = {
  language: {
    login: 'Log in', // 登陆按钮
    userName: 'User name', // 用户名
    foodCategory: 'If Vegetarian, please check', // 食物类别
    veryPoor: 'Very Poor', // 極差
    poor: 'Poor', // 差
    good: 'Fair', // 可
    excellent: 'Good', // 優
    outstanding: 'Excellent', // 極優
    tripTitle: 'Itinerary/Service Evaluation', // 行程主标题
    serviceTitle: 'Overall Evaluation', // 整体服务主标题
    save: 'Save', // 保存按钮
    submit: 'Submit', // 提交按钮
    home: 'Back to Main', // 返回首页按钮
    saveSuccessTitle: 'Saved', // 成功页面 标题
    saveSuccessContent: 'Your data has been saved', // 成功页面 内容
    close: 'Close', // 送出提示  关闭按钮
    submitTitle: 'Send notification', // 送出提示  标题
    submitContent: 'Once the data is sent, it cannot be edited. If you would like to finish the evaluation later, please click "Save" so that you may return to this page later.', // 送出提示 内容
    confirmSubmit: 'Confirm submit', // 送出提示  确认按钮
    submitSuccessTitle: 'Submission sucessful!', // 送出成功页面 标题
    serviceTripTitle: 'Overall Evaluation', // 综合评价页面 标题
    submitSuccessContent: `<h2>You have successfully submitted the survey!<br>Thank you for your participation!</h2><p>More exciting journeys waiting for you to experience.<br><a href="https://www.signettours.com">www.signettours.com</a></p>`, // 送出成功页面 内容
    dayRateTitle: 'Evaluation', // 行程页面 标题
    dayInputTitle: 'Comment', // 行程页面 input 标题
    dayInputTips: 'Optional', // 行程页面 input 提示文字
    previousDay: 'Previous Day', // 上一天
    nextDay: 'Next Day', // 下一天
    nextPage: 'Next Page', // 下一頁
    previousPage: 'Previous Page', // 上一頁
    loginTips: 'Satisfaction Questionnaire', // 登陆提示
    SurveySubmittedLogo: '/img/logo-en.png', // 已经提交过问卷LOGO
    SurveySubmittedContent: 'You have submitted the questionnaire. Thank you for your participation' // 已经提交过问卷内容
  }
}
